/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  function domEach(selector, callback) {
    if (!selector) return;
    var selected = document.querySelectorAll(selector);
    var i = 0,
      l = selected.length;
    for (; i < l; ++i) callback(selected[i]);
  }

  function tabToggler(evt) {
    var toggler = evt.target;
    var panel = toggler.nextElementSibling;
    if (toggler && panel) {
      if (toggler.matches(".active")) {
        panel.style.display = "none";
        toggler.classList.remove("active");
      } else {
        panel.style.display = "block";
        toggler.classList.add("active");
      }
    }
    return false;
  }

  // quickfilter for download page
  function quickFilter(_search) {
    var found = 0,
      search = ("" + _search).toLowerCase();
    domEach(".acc-text .grid__item", function (elm) {
      var product = elm.getAttribute("data-product");
      if (product && product.indexOf(search) != -1) {
        //       console.log(product, elm)
        elm.style.display = "block";
        var parent = elm.parentNode;
      } else {
        elm.style.display = "none";
      }
    });

    domEach(".acc-text .grid", function (elm) {
      var items = elm.querySelectorAll(".grid__item");
      var counter = 0,
        a = 0,
        b = items.length;
      for (; a < b; ++a) {
        if (items[a].style.display === "block") counter++;
      }

      if (counter) {
        elm.classList.remove("none");
        elm.classList.add("show");
        found++;
      } else {
        elm.classList.add("none");
        elm.classList.remove("show");
      }
    });

    if (found) {
      domEach(".acc-head", function (elm) {
        var container = elm.nextElementSibling;
        var foundAny = container.querySelectorAll(".grid.show").length;
        //       console.log(container,foundAny)
        if (!elm.matches(".active") && foundAny) elm.click();
        if (elm.matches(".active") && !foundAny) elm.click();
      });
    }
  }

  function qfilterInit() {
    var input = document.getElementById("quickfilter");
    if (input) {
      input.addEventListener("input", function (event) {
        var text = event.target.value;
        quickFilter(text);
      });
    }
  }

  function pageInit() {
    domEach("h3.acc-head", function (elm) {
      elm.addEventListener("click", tabToggler, false);
    });

    // store product name in dom
    domEach(".acc-text .grid__item", function (elm) {
      var text = elm.querySelector("p").innerText;
      elm.dataset.product = text.toLowerCase();
    });
  }

  window.addEventListener("DOMContentLoaded", function (evt) {
    pageInit();
    qfilterInit();
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
